import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import HomeHeader from '../../components/HomeHeader'
import ProfileForm from './components/ProfileForm'
import ProfileSwitch from './components/ProfileSwitch'
import ProfileText from './components/ProfileText'

interface RouteParams {
  typeId: string
  orderId: string
}

type ProfileProps = RouteComponentProps<RouteParams>

const Profile: React.FC<ProfileProps> = ({
  match: {
    params: { typeId, orderId },
  },
}) => {
  const [typeInfo, setTypeInfo] = useState<string>('geral')
  const [order, setOrder] = useState<string>('')

  useEffect(() => {
    setTypeInfo(typeId)
  }, [typeId])

  useEffect(() => {
    setOrder(orderId)
  }, [orderId])
  return (
    <>
      <HomeHeader />
      <ProfileSwitch type={typeInfo} switchType={setTypeInfo} />
      <ProfileText type={typeInfo} />
      <ProfileForm type={typeInfo} order={order} />
    </>
  )
}

export default Profile
